import React, { useState } from "react";
import { MapPinLine } from "@phosphor-icons/react";

const KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY || "";

/** Google Street View property image with graceful fallback when key is missing or image fails. */
export default function PropertyImage({ address, city, state, zip, height = 120 }) {
  const [failed, setFailed] = useState(false);
  const loc = encodeURIComponent(`${address}, ${city}, ${state} ${zip || ""}`.trim());
  const url = KEY
    ? `https://maps.googleapis.com/maps/api/streetview?size=640x260&location=${loc}&fov=80&pitch=0&key=${KEY}`
    : null;

  if (!KEY || failed) {
    return (
      <div
        className="w-full flex items-center justify-center bg-[#111114] border-b border-zinc-800 relative overflow-hidden"
        style={{ height }}
        data-testid="property-image-placeholder"
      >
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage:
              "radial-gradient(circle at 30% 30%, rgba(16,185,129,0.15), transparent 40%), radial-gradient(circle at 70% 70%, rgba(59,130,246,0.15), transparent 45%)",
          }}
        />
        <div className="relative flex flex-col items-center text-zinc-500">
          <MapPinLine size={22} className="mb-1" />
          <div className="text-[10px] mono uppercase tracking-[0.15em]">
            {KEY ? "no street view" : "street view · add API key"}
          </div>
        </div>
      </div>
    );
  }

  return (
    <img
      src={url}
      alt={`${address}, ${city}`}
      onError={() => setFailed(true)}
      className="w-full object-cover border-b border-zinc-800"
      style={{ height }}
      data-testid="property-image"
    />
  );
}
